// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_f6u","cls2":"DebugPage-cls2_YYE DebugPage-cls1_f6u"};